import { render, staticRenderFns } from "./VolunteerComposition.vue?vue&type=template&id=70fc84a4&scoped=true"
import script from "./VolunteerComposition.vue?vue&type=script&lang=js"
export * from "./VolunteerComposition.vue?vue&type=script&lang=js"
import style0 from "./VolunteerComposition.vue?vue&type=style&index=0&id=70fc84a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fc84a4",
  null
  
)

export default component.exports